// Download speed measured from the live stream's own video segments (HLSPlayer reports each
// one hls.js loads). It is the Internet card's reading in browsers that have no built-in
// estimate (Firefox, Safari - no navigator.connection): nothing extra is downloaded, and it
// works there because the player sees each segment's bytes itself (the browser's Resource
// Timing hides them for Mux, which sends no Timing-Allow-Origin).
//   Per segment: bytes / time from the first byte to the last. Small segments (audio, a thin
//   live edge) are left out - their time is mostly waiting, not downloading. The reading is
//   the median of the last few, so one odd segment doesn't swing it.
//   getStreamBandwidth() -> { mbps, at } | null (no stream playing / nothing measured yet)

export const MIN_SEGMENT_BYTES = 100 * 1024;
export const MIN_SEGMENT_MS = 20;
const WINDOW = 5;

let samples = []; // { source, mbps }
let snapshot = null;
const listeners = new Set();

function publish() {
  const values = samples.map((s) => s.mbps).sort((a, b) => a - b);
  snapshot = values.length ? { mbps: values[Math.floor((values.length - 1) / 2)], at: Date.now() } : null;
  listeners.forEach((fn) => fn());
}

// source: the reporting player (one per HLSPlayer session), so its samples go when it stops.
export function reportSegmentLoad(source, { bytes, ms } = {}) {
  if (!(bytes >= MIN_SEGMENT_BYTES) || !(ms >= MIN_SEGMENT_MS)) return;
  samples = [...samples, { source, mbps: (bytes * 8) / (ms / 1000) / 1e6 }].slice(-WINDOW);
  publish();
}

export function clearStreamBandwidth(source) {
  const kept = samples.filter((s) => s.source !== source);
  if (kept.length === samples.length) return;
  samples = kept;
  publish();
}

export function subscribeStreamBandwidth(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function getStreamBandwidth() {
  return snapshot;
}

// Tests only.
export function __resetStreamBandwidth() {
  samples = [];
  snapshot = null;
  listeners.clear();
}
